import ActionsForm from '@/shared/mixins/actionsForm'
// import QmaReportTable from '../components/qmaReportTable/qmaReportTable.vue'
import QmaReportFiltro from '../../components/qmaReportTable/components/qmaReportFiltro/qmaReportFiltro.vue'
import QmaReportPainel from '../../components/qmaReportTable/components/qmaPainelReport/qmaPainelReport.vue'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import QmaReportPivsTable from '@/views/private/qma/qmaReport/qmaReportPivs/components/qmaReportPivsTable/qmaReportPivsTable.vue'
import QmaReportPitTable from '@/views/private/qma/qmaReport/qmaReportPit/components/qmaReportPitTable/qmaReportPitTable.vue'
import QmaReportLvTable from '@/views/private/qma/qmaReport/qmaReportLv/components/qmaReportLvTable/qmaReportLvTable.vue'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'qmaReport',
  components: {HeadDetailsGama, QmaReportPainel, QmaReportFiltro, QmaReportPivsTable, QmaReportPitTable, QmaReportLvTable},
  mixins: [ActionsForm],
  props: ['report'],
  data () {
    return {
      formSearch: {}
    }
  },
  mounted () {
  },
  methods: {
    search (fluxo, data) {
      if (fluxo === 0) {
        this.$refs.tableRelatorioLvQMA.formSearch = data
        this.$refs.tableRelatorioLvQMA.onLoad()
      } else if (fluxo === 1) {
        this.$refs.tableRelatorioPitQMA.formSearch = data
        this.$refs.tableRelatorioPitQMA.onLoad()
      } else if (fluxo === 2) {
        this.$refs.tableRelatorioPivsQMA.formSearch = data
        this.$refs.tableRelatorioPivsQMA.onLoad()
      } else {
        toast.error('Erro ao carregar informações')
      }
    },
    quantitativos (data) {
      this.$refs.tableRelatorioQMA.quantitativosPDF = data
    },
    contagemPendentes (data) {
      this.$emit('contagemRelatorio', data)
    },
    dataRelatoioQmaLength (data) {
      this.$emit('dataRelatoioQmaLength', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaReport/components/qmaReport/qmaReport.js